module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "rch1",
      "title": "1. The Oneida World before Christianity"
    }
  }, [_c('p', {
    staticClass: "cn"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253041401_Contents#ch1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253041401_Contents#ch1"
    }
  }, [_vm._v("THE ONEIDA WORLD BEFORE CHRISTIANITY")])]), _vm._v(" "), _c('p', {
    staticClass: "cta"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253041401_Contents#ch1"
    }
  }, [_vm._v("Laurence M. Hauptman")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NEIDAS ARE ONE OF THE FIVE ORIGINAL")]), _vm._v(" nations of the Iroquois League or Confederacy, holding nine out of fifty sachemships within it. A sixth nation, the Tuscaroras, was incorporated into the League between 1711 and 1724. To the east of the Oneidas, the Mohawk Nation held sway, and to the west was the homeland of the Onondaga Nation, the central fire of the Iroquois League."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn1",
      "id": "fn1"
    }
  }, [_vm._v("1")])]), _vm._v(" According to one estimate of the Oneidas before the smallpox epidemic of 1634, their population was between 1,500 and 1,800 individuals."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn2",
      "id": "fn2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Oneidas’ original homeland in today’s central New York included approximately 5 to 6 million acres of land at the time of European contact. It stretched from the Saint Lawrence River valley to just beyond what is today the New York–Pennsylvania boundary line. At the heart of their estate was the short portage between the Mohawk River and Wood Creek, known as the Oneida Carrying Place, which was strategic for both the Hodinöhsö:ni´ and, later, for Euro-Americans. To the southeast are the headwaters of the Mohawk, which flows eastward until it joins the Hudson, which connects the Atlantic Ocean at New York City. On the north was Wood Creek, which, along with Fish Creek, Oneida Lake, and the Oswego River, was a major passageway to Lake Ontario and the rest of the Great Lakes. From Wood Creek, Oneida lands ran southeast along the Unadilla River to the Susquehanna and then to the second branch of the Delaware River. To the north, where great timber and wildlife resources abounded in the western Adirondacks, the Oneida homeland stretched from East Canada Creek to West Canada Creek near today’s Poland, New York, and then west across the headwaters of the Black and Oswegatchie Rivers and northwest to the Saint Lawrence River following the shoreline of Lake Ontario southward to nearly the rift of the Onondaga River valley. It ran due south to a point five miles west of the outlet of Oneida Lake, one "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("of the great fisheries of eastern North America, and then southeast to Chittenango Falls on Chittenango Creek and Cazenovia Lake. This territory then returned to its starting point via the headwaters of the Oswego River and the course of the Susquehanna."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn3",
      "id": "fn3"
    }
  }, [_vm._v("3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of the central beliefs of Oneida existence, then and now, concerns a standing stone, an inanimate boulder unlike any other stone. The elders in central New York told the children stories about this magical stone and other Hodinöhsö:ni´ legends when storytelling was at a premium during the harsh winter months. It was supposed to bring good luck when Oneidas took the warpath. Unaided by human hands, it would suddenly appear every time the Oneidas would move their villages in their homeland. The Oneidas conducted their great councils around this sacred stone, where they resolved questions presented to them and worshipped the Creator."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn4",
      "id": "fn4"
    }
  }, [_vm._v("4")])]), _vm._v(" Finally, when the village at Oneida Castle was founded, the stone remained there. Consequently, it is no coincidence that the Oneidas call themselves “Onyota´a:ká: the people of the standing stone.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn5",
      "id": "fn5"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the seventeenth century, the Oneida world was a matrilineal, matrilocal society organized into three clans—Wolf, Bear, and Turtle. Each clan was headed by a matron, and each clan appointed three chiefs. Clan mothers had control of chiefly titles. In the seventeenth century, the forest world was the province of men, and they handled diplomacy, the hunt, and war; however, in the clearing (or village), women had key roles in nominating male leadership, in horticulture, in child-rearing, and within the walls of the longhouse residence."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn6",
      "id": "fn6"
    }
  }, [_vm._v("6")])]), _vm._v(" Longhouses were located within the Iroquois’ palisaded villages and were directly associated with maternal lineages, since matrons owned the longhouses. These structures included three to five fireplaces and provided shelter for two nuclear families of five or six persons each. Longhouses were more than residential units. They became the Hodinöhsö:ni´ symbol of identity; hence, the Iroquois referred to themselves as the people of the longhouse."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn7",
      "id": "fn7"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1634, the Dutch West India Company sent Harmen Meyndertsz van den Bogaert, a twenty-two-year-old barber surgeon, into Mohawk and Oneida Country to ascertain why fur supplies to the trading house at Fort Orange had declined. On December 30, van den Bogaert described an Oneida village in his journal. Referring to this palisaded village as a castle, he claimed that the community was “on a high hill, and was surrounded with two rows of palisades, 767 steps in circumference in which there are 66 houses, but built much better and higher than all the others.” The Dutchman observed “many wooden gables on the houses which were painted with all sorts of animals” and indicated that the Oneidas, unlike other Indians he had previously encountered, slept “mostly on platforms” in their longhouses. He appeared to be startled by the substantial food supply within these longhouses in the dead of winter: “I saw houses with 60, 70 and more dried salmon” there."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn8",
      "id": "fn8"
    }
  }, [_vm._v("8")])]), _vm._v(" It is clear from this description that Oneidas took advantage of the "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("great fishing opportunities that existed a short distance from their villages. These included access to Fish and Wood Creeks as well as to the Mohawk, Oneida, and Oswego Rivers. Even more importantly was their proximity to Oneida Lake and to Lake Ontario, which provided a limitless food supply and opportunities to sell fish to other Native peoples as well."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn9",
      "id": "fn9"
    }
  }, [_vm._v("9")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite the importance of fishing, the Oneidas were primarily horticulturalists and supplemented their food supply by hunting. They raised maize, beans, and squash, referred to by the Iroquois as the “three sisters.” Besides domesticated crops, they gathered wild plant foods, such as wild berries and nuts. As hunters, they sought out the white-tailed deer, which was their primary meat supply. Thus, as the van den Bogaert journal shows, their diet was quite diverse. The Dutchman described a vast variety of foods that were served in Mohawk and Oneida Country, including bear, beaver, turkey, rabbit, venison, fresh and dried salmon, corn bread, baked and boiled pumpkins, dried blueberries and strawberries, sunflower seeds, chestnuts, and beans and corn, some cooked in bear fat and others cooked in turkey fat."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn10",
      "id": "fn10"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Early contact with Europeans in the first four decades of the seventeenth century brought rapid changes to Oneida Country. Most devastating were waves of epidemic diseases, such as smallpox, that came as a result of contact. With the founding of trade at Fort Orange by the Dutch in 1614, Oneidas were slowly incorporated into the world economy through their trade in deerskin hides and, more importantly, beaver skins. More than two decades before Jesuit missionaries came to Oneida territory, van den Bogaert’s journal describes many of these changes. By that time, the Mohawks and Oneidas were already using European-introduced iron axes, brass kettles, nails, razors, scissors, and cloth and seeking these items out in trade."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn11",
      "id": "fn11"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As one of the founding members of the Iroquois League, the Oneidas were affected by their relations with the other four nations. While the Iroquois League promoted cooperation that at times led to powerful alliances among its members, when consensus could not be achieved, individual nations often went their own way. Despite frequent warfare in the seventeenth century that included Iroquois conflicts with the Wenros (1638), Eries (1650–1680), Neutrals (1650–1651), Susquehannocks (1675–1676), and Ojibwes (1696–1701), ethnohistorian Jack Campisi rightly points out that rarely did “all the Five Nations take the field in concerted action against a common enemy.” He adds, “The League represented a higher level of integration, a shared symbol based on commonly held beliefs and values given voice through an elaborate ceremonial structure.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn12",
      "id": "fn12"
    }
  }, [_vm._v("12")])]), _vm._v(" Unity, however, was encouraged through seasonal ceremonies and common rituals. The Iroquoian ceremonial cycle included and still includes the Midwinter (January/February), Maple (March), Cornplanting (May), Strawberry (June), Green Corn (September), and Harvest (October) ceremonies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("Two major myths of the Iroquoian cosmology are the Earth Grasper, or the Woman Who Fell from the Sky (Sky Woman), and the Message of the Peacemaker, or the Origin of the League of the Iroquois. The first recounts the Iroquois version of the creation of the world through Sky Woman’s fall from Sky World. It has been called “one of the great pieces of ancient oral literature of the Americas.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn13",
      "id": "fn13"
    }
  }, [_vm._v("13")])]), _vm._v(" In its numerous versions retold over the centuries, the epic offers the reason for women’s special role in Iroquoian society, describes the relationship of human beings to the natural world, explains the origins of Iroquoian horticulture and dance, and offers an explanation for why life is both a blessing and a hardship. The prominent anthropologist William N. Fenton described nine component parts of this epic: the description of the Sky World, the “uprooting of the life-giving tree,” the “casting down of Sky Woman,” water animals diving to save Sky Woman, “the establishment of the earth on the turtle’s back,” “Sky Woman’s daughter gives birth to twins known as ‘the Good-Minded and Evil-Minded,” “Good-Minded, a culture hero, frees the animals pent up by his twin brother and procures maize,” the twins battle in a Herculean manner, and, finally, the “banishment of Evil-Minded while Good-Minded and Sky Woman return to the Sky World, promising to return one day.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn14",
      "id": "fn14"
    }
  }, [_vm._v("14")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The other epic, first recorded by Euro-Americans in 1743, is related to the Peacemaker’s legacy—namely, how the Five Nations stopped feuding and joined in the Great Peace, thereby creating the Iroquois League. This is at the heart of what the Iroquois call, in the Oneida language, "), _c('i', [_vm._v("Kayanla:kówa")]), _vm._v(", the Great Law of Peace and Power."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn15",
      "id": "fn15"
    }
  }, [_vm._v("15")])]), _vm._v(" The Peacemaker, born of a virgin on the north side of a great lake, crosses these waters in a white stone canoe with the message from the Creator for the five nations to end their incessant internecine warfare. He meets grief-stricken Hiawatha, whose family had been killed by Onondaga chief Thadoda:ho´. After hearing the Peacemaker’s message and receiving wampum brought by the Peacemaker to help him deal with his grief and wipe away his tears, Hiawatha accepts the assignment to help end conflict within the five nations. The importance of how grief is overcome becomes an important aspect of Iroquoian existence. The Peacemaker through his convert and missionary Hiawatha slowly convinces the Oneidas, Mohawks, Cayugas, and Senecas of the rightness of this plan, but he is stymied by Thadoda:ho´ at Onondaga. Thadoda:ho´, a cannibal, is reluctant to accept the message. He has earthly and evil thoughts and is often depicted by Iroquois artists as having snakes in his hair. Faced with opposition from the four nations and given assurances that the Onondagas would have a special place—more sachems within the league structure than other nations—the practical Thadoda:ho´ agrees to end his cannibalistic ways, have the snakes combed from his hair, and join in with the other four nations. He accepts the Creator’s message brought by the Peacemaker and his emissary Hiawatha, thus forming the Iroquois League of the Five Nations."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn16",
      "id": "fn16"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition to the concept of the Peacemaker’s virgin birth and his journey, the epic has other elements that parallel Christian theology. Similar to Christ "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("miraculously walking on water, the Peacemaker is able to magically cross the waters in his stone canoe. Moreover, the theme of redemption, so much a part of Catholic theology, is included in this Iroquoian epic. Even evildoers and cannibals such as Chief Thadoda:ho´ have the ability to change and reform themselves."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn17",
      "id": "fn17"
    }
  }, [_vm._v("17")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This epic is still repeated today by the Iroquois nations in the Condolence Council, a ritual for mourning and installing chiefs. The ritual is essential for understanding the Hodinöhsö:ni´, their beliefs, culture, and history, as well as the nature of Iroquois–Indian and later Iroquois–Euro-American diplomacy. In the colonial era, the Condolence was “the ritual paradigm that governed the proceedings [of forest diplomacy and] guided the behavior of Iroquoian and Algonquian speakers alike throughout the lower Great Lakes.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn18",
      "id": "fn18"
    }
  }, [_vm._v("18")])]), _vm._v(" Both chiefs and colonial officials were mourned during this ritual. According to Fenton, in order to cement alliances, the Hodinöhsö:ni´ employed metaphors about “keeping the paths open by clearing rivers, rapids, and roads, polishing a chain and maintaining a perpetual fire to bind.” He adds, “Perhaps the most famous metaphor was the Chain. Keeping the Chain of Friendship bright and free of rust required frequent meetings.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn19",
      "id": "fn19"
    }
  }, [_vm._v("19")])]), _vm._v(" As we will see in later chapters, the metaphor was later carried to Wisconsin by the Oneidas in the third and fourth decades of the nineteenth century and had a direct bearing on the formation of the Oneida bond with the Episcopal Church. Moreover, the Wisconsin Oneidas’ celebration of July 4 in the mid-nineteenth century had elements of the Condolence Council ritual as well."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn20",
      "id": "fn20"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ceremony, in effect, was used to reinvigorate Iroquois existence, renew political forms, restore society, and build or strengthen alliances. The Iroquois expectation was that all the guests and outsiders observe and respect these traditions and learn the proper etiquette and forms of the ritual. Fenton adds that through the seriousness and religiosity of the Condolence Council, the Iroquois attempted to manipulate the foreboding white world to their own advantage."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn21",
      "id": "fn21"
    }
  }, [_vm._v("21")])]), _vm._v(" Perhaps this is overstating its role; however, in order for Iroquoian people to make sense of the “foreigner,” they had to incorporate him or her into their cultural ways of doing things, which might or might not mean surreptitiously manipulating the situation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Much like what the Peacemaker did for Hiawatha, the Condolence Council does for mourning dead chiefs, lifting up the minds of bereaved relatives, and installing successor sachems. The council consists of sixteen separate elements, including rites known as the Roll Call of the Founders, the Welcome at the Wood’s Edge, the Recitation of Laws, the Requickening Address, the Six Songs of Requiem, and the Charge to the New Chief. Invited guests gathered at the wood’s edge and were welcomed into the village, where the chiefs read the Roll Call of the Founders, recounting the sacrifices of past leaders. Dead chiefs were recognized for their service to the nation, mourned, and their successors raised and validated, “requickened” in the titles of the deceased, and charged in their new duties to carry out the people’s will."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn22",
      "id": "fn22"
    }
  }, [_vm._v("22")])]), _vm._v(" The ritual was followed by a feast. In addition to the social dancing "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("that always followed the end of the ten-day period of the Condolence Council, a game of lacrosse, known as the Creator’s game, was included as part of the rite. It was meant to entertain the Creator, but it also defused social tensions, discouraged internecine warfare, kept warriors fit, and encouraged the crowd to cheer players who were relatives of the deceased.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the surface, one might inaccurately conclude that the coming of Christianity submerged the traditional Oneida religious traditions and altered them beyond recognition, especially after the Oneidas resettled in Wisconsin. Yet, Campisi states that the Good-Minded Twin, "), _c('i', [_vm._v("Thaluhyawá:ku")]), _vm._v(" in the Iroquoian creation epic, “became synonymous with Jesus Christ.” He also points out that the Oneidas’ tradition of collecting water before sunrise on Easter morning fit well within the Oneida traditions since they used their own version of holy water, "), _c('i', [_vm._v("kanekká:nol")]), _vm._v(", for “therapeutic purposes.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn23",
      "id": "fn23"
    }
  }, [_vm._v("23")])]), _vm._v(" In the accounts of the WPA Oneida Language and Folklore Project of the late 1930s, the False Face Medicine Society is described as continuing in the Wisconsin setting even into the twentieth century, and references to Oneida traditional herbalist practices are also described as persisting. In addition, the ceremonial bestowing of Oneida names continued during July 4 celebrations at Oneida into the mid-nineteenth century. Moreover, Oneidas brought to Wisconsin traditional all-night wakes accompanied by songs and eulogies in Oneida that often lasted three days. They also brought the traditional Iroquoian ten-day feast, at which time possessions of the deceased were distributed to kin and friends, to their new surroundings."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn24",
      "id": "fn24"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although clans declined and ceremonies were abandoned, the “few remaining features relative to health, spirits, and death persisted but were absorbed into the corpus of Christian belief.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn25",
      "id": "fn25"
    }
  }, [_vm._v("25")])]), _vm._v(" I was to observe this firsthand on June 14, 2016. On that day, I attended a ceremony at the Oneidas’ Church of the Holy Apostles graveyard. I stood silently in the crowd, observing a solemn ceremony. His Excellency Reverend Matthew Gunter, the bishop of Fond du Lac, consecrated the Oneida cemetery containing gravesites of Oneidas and their non-Indian missionaries since the nation’s move from New York in the 1820s and 1830s. The bishop read the names associated with this historic parish, paying homage to them, almost as if he was recounting the Roll Call of the Founders in a Condolence Council ritual, a reminder that the past and present sometimes intersect in mysterious and long-forgotten ways."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn26",
      "id": "fn26"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "noteh"
  }, [_vm._v("Notes")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "rfn1"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/#fn1"
    }
  }, [_vm._v("1")]), _vm._v(". The best overview of Oneida ethnohistory is still Jack Campisi, “Ethnic Identity and Boundary Maintenance in Three Oneida Communities” (PhD diss., State University of New York at Albany, 1974).")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "rfn2"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/#fn2"
    }
  }, [_vm._v("2")]), _vm._v(". William A. Starna, “The Oneida Homeland in the Seventeenth Century,” in "), _c('i', [_vm._v("The Oneida Indian Experience: Two Perspectives")]), _vm._v(", ed. Jack Campisi and Laurence M. Hauptman (Syracuse, NY: Syracuse University Press, 1988) 16.")])]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "rfn3"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/#fn3"
    }
  }, [_vm._v("3")]), _vm._v(". Ibid., 25–28. The Oneidas’ traditional territorial boundaries were confirmed after the American Revolution in the federal treaty with the Six Nations at Fort Stanwix, 7 "), _c('i', [_vm._v("Stat")]), _vm._v("., 15 (October 22, 1784).")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "rfn4"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/#fn4"
    }
  }, [_vm._v("4")]), _vm._v(". Anthony Wonderley, "), _c('i', [_vm._v("Oneida Iroquois Folklore, Myth, and History: New York Oral Narrative from the Notes of H. E. Allen")]), _vm._v(" (Syracuse, NY: Syracuse University Press, 2004), 1–14, 24–31; Charles A. Huegenin, “The Sacred Stone of the Oneidas,” "), _c('i', [_vm._v("New York Folklore Quarterly")]), _vm._v(" 8 (1957): 16–22.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "rfn5"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/#fn5"
    }
  }, [_vm._v("5")]), _vm._v(". Karim M. Tiro, "), _c('i', [_vm._v("The People of the Standing Stone: The Oneida Nation from the Revolution Through the Era of Removal")]), _vm._v(" (Amherst: University of Massachusetts Press, 2011), 1–2.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "rfn6"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/#fn6"
    }
  }, [_vm._v("6")]), _vm._v(". Campisi, “Ethnic Identity and Boundary Maintenance,” 37–43; Elisabeth Tooker, “Women in Iroquois Society,” in "), _c('i', [_vm._v("Extending the Rafters: Interdisciplinary Approaches to Iroquoian Studies")]), _vm._v(", ed. Michael Foster, Jack Campisi, and Marianne Mithun (Albany, NY: SUNY Press, 1984), 109–23.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "rfn7"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/#fn7"
    }
  }, [_vm._v("7")]), _vm._v(". William N. Fenton, "), _c('i', [_vm._v("The Great Law and the Longhouse: A Political History of the Iroquois Confederacy")]), _vm._v(" (Norman: University of Oklahoma Press, 1998), 23–24.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "rfn8"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/#fn8"
    }
  }, [_vm._v("8")]), _vm._v(". Harmen Meyendertsz van den Bogaert, "), _c('i', [_vm._v("A Journey into Mohawk and Oneida Country, 1634–1635")]), _vm._v(", trans. and ed. Charles Gehring and William A. Starna (Syracuse, NY: Syracuse University Press, 1988), 12–13.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "rfn9"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/#fn9"
    }
  }, [_vm._v("9")]), _vm._v(". Ibid., 12–22.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "rfn10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#fn10"
    }
  }, [_vm._v("10")]), _vm._v(". Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "rfn11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#fn11"
    }
  }, [_vm._v("11")]), _vm._v(". Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "rfn12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#fn12"
    }
  }, [_vm._v("12")]), _vm._v(". Campisi, “Ethnic Identity and Boundary Maintenance,” 51.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "rfn13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#fn13"
    }
  }, [_vm._v("13")]), _vm._v(". Demus Elm and Harvey Antone, "), _c('i', [_vm._v("The Oneida Creation Story")]), _vm._v(", trans. and ed. Floyd G. Lounsbury and Bryan Gick (Lincoln: University of Nebraska Press, 2000), 2.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "rfn14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#fn14"
    }
  }, [_vm._v("14")]), _vm._v(". Fenton, "), _c('i', [_vm._v("The Great Law and the Longhouse")]), _vm._v(", 35.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "rfn15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#fn15"
    }
  }, [_vm._v("15")]), _vm._v(". Amos Christjohn and Maria Hinton, "), _c('i', [_vm._v("An Oneida Dictionary")]), _vm._v(", ed. Clifford Abbott (Green Bay: University of Wisconsin at Green Bay, 1996), 597.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "rfn16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#fn16"
    }
  }, [_vm._v("16")]), _vm._v(". Fenton, "), _c('i', [_vm._v("The Great Law and the Longhouse")]), _vm._v(", 51–103.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "rfn17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#fn17"
    }
  }, [_vm._v("17")]), _vm._v(". Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "rfn18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#fn18"
    }
  }, [_vm._v("18")]), _vm._v(". Ibid., 10.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "rfn19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#fn19"
    }
  }, [_vm._v("19")]), _vm._v(". William N. Fenton, “Structure, Continuity, and Change in the Process of Treaty-making,” in "), _c('i', [_vm._v("The History and Culture of Iroquois Diplomacy: An Interdisciplinary Guide of the Treaties of the Six Nations and Their League")]), _vm._v(", ed. Francis Jennings, William N. Fenton, Mary A. Druke, and David R. Miller (Syracuse, NY: Syracuse University Press, 1985), 22.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "rfn20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#fn20"
    }
  }, [_vm._v("20")]), _vm._v(". “Celebration of the Fourth of July at Oneida Settlement: Speech of Daniel Bread,” "), _c('i', [_vm._v("Green Bay Advocate")]), _vm._v(", July 4, 1854. For an analysis of how these Oneida Fourth of July speeches and commemorations fit into the Condolence Council paradigm, see Lawrence M. Hauptman and L. Gordon McLester III, "), _c('i', [_vm._v("Chief Daniel Bread and the Oneida Nation of Indians of Wisconsin")]), _vm._v(" (Norman: University of Oklahoma Press, 2005), 121–26.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "rfn21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#fn21"
    }
  }, [_vm._v("21")]), _vm._v(". Fenton, "), _c('i', [_vm._v("The Great Law and the Longhouse")]), _vm._v(", 6.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "rfn22"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#fn22"
    }
  }, [_vm._v("22")]), _vm._v(". Ibid., 135–223.")])]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "rfn23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#fn23"
    }
  }, [_vm._v("23")]), _vm._v(". Campisi, “Ethnic Identity and Boundary Maintenance,” 128.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "rfn24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#fn24"
    }
  }, [_vm._v("24")]), _vm._v(". Ibid., 127–31.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "rfn25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#fn25"
    }
  }, [_vm._v("25")]), _vm._v(". Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "rfn26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#fn26"
    }
  }, [_vm._v("26")]), _vm._v(". For more on the eulogy, the Roll Call of the Founders in the Condolence Council ritual, see Fenton, "), _c('i', [_vm._v("The Great Law and Longhouse")]), _vm._v(", 190–202.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19813a77","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253041401_Chapter_1.vue
// module id = 99
// module chunks = 0